const networks = {
    1: 'Mainnet',
    10: 'Optimisim',
    31337: 'Test',
};

export default networks;
